// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__RAkLZ"};